import SectionHeading from "@/components/base/SectionHeading";
import { interpretations } from "@/mocks/interpretations";

export default function HotInterpretations() {
  const list = interpretations.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <SectionHeading
        eyebrow="热门解读"
        title="剧情深度解读"
        description="从人物弧光到镜头意象，帮你看到剧情表面之外的那一层表达。"
        actionLabel="前往剧情介绍"
        actionTo="/plot"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {list.map((item) => (
          <article
            key={item.id}
            className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={`年轻的母亲 剧情解读 ${item.title}`}
                title={`年轻的母亲 剧情解读 ${item.title}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-accent-950 text-xs font-medium font-label">
                {item.tag}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2.5 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                {item.excerpt}
              </p>
              <div className="mt-4 pt-4 border-t border-background-200/70 flex items-center justify-between text-xs text-foreground-400 font-label">
                <span>{item.author}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {item.date}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}